module.exports = __webpack_public_path__ + "img/l4.ff6bd11.svg";